import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EAlertType } from '../../types/authenticationWidget/alertType';

export interface IAuthenticationWidgetState {
  userId?: number;
  autoRefresh: boolean;
  alert: EAlertType | null;
  // нужно, чтобы сохранить логику установки начальной вьюхи в контексте авторизации
  useDefaultView: boolean;
  viewData: unknown;
  // откуда была запрошена авторизация
  source: string | null;
}

export const initialState: IAuthenticationWidgetState = {
  autoRefresh: true,
  alert: null,
  useDefaultView: false,
  viewData: null,
  source: null,
};

const authenticationWidgetSlice = createSlice({
  name: 'authenticationWidgetSlice',
  initialState,
  reducers: {
    setAuthenticationWidgetData: (_state, action: PayloadAction<IAuthenticationWidgetState>) => action.payload,
  },
});

export const {
  reducer: authenticationWidgetReducer,
  actions: { setAuthenticationWidgetData },
} = authenticationWidgetSlice;
